import { Resolvers, scalarResolvers, VirtualObjectType } from '@spazious/dollhouse-graphql';

import { ApolloContext } from '../context.js';

import { createProposal } from './createProposal.js';
import { FComposition, fcomposition } from './fcomposition.js';
import { fcompositions } from './fcompositions.js';
import { templates } from './templates.js';
import { updateGraph } from './updateGraph.js';
import { virtualObject } from './virtualObject.js';
import { virtualObjects } from './virtualObjects.js';
import { virtualSpace } from './virtualSpace.js';

/**
 * Resolvers for the GraphQL schema.
 */
export const resolvers: Resolvers<ApolloContext> = {
  ...scalarResolvers,
  Furniture: {
    __isTypeOf: (obj) => obj.type === VirtualObjectType.Furniture,
  },
  Decoration: {
    __isTypeOf: (obj) => obj.type === VirtualObjectType.Decoration,
  },
  FComposition,
  Query: {
    virtualSpace,
    virtualObject,
    virtualObjects,
    fcomposition,
    fcompositions,
    templates,
  },
  Mutation: {
    createGraph() {
      throw new Error('Not implemented');
    },
    createProposal,
    updateGraph,
  },
};
